import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

import store from '../store';

const AUTH_GUARD = async (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
   /* Skipping the unavailable page. */
   if (['unavailable'].includes(to.name as string)) return next();

   /* Fetching the user information from the backend. */
   await fetchUserInfo();

   return next();
};

async function fetchUserInfo() {
   if (!store.state.user?.user_info) {
      await store.dispatch('user/getInfo');
   }
}

export default AUTH_GUARD;
